(function () {
  'use strict';

  function makePackId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'kit-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function getKitConfig() {
    var el = document.getElementById('girom-kit-config');
    if (!el) return { components: [] };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { components: [] };
    }
  }

  function buildKitItems() {
    var selector = document.getElementById('pro0var');
    var pro0var = selector && selector.value;
    var qtyInput = document.querySelector('.quantity__input');
    var cantidad = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var titleEl = document.querySelector('.product__title h1');
    var optionText = selector && selector.options[selector.selectedIndex]
      ? selector.options[selector.selectedIndex].text.trim()
      : '';
    var para = (titleEl ? titleEl.textContent.trim() : 'Kit') + ' - ' + optionText;
    var packId = makePackId();
    var config = getKitConfig();
    var items = [];

    if (!pro0var) return null;

    items.push({
      quantity: cantidad,
      id: parseInt(pro0var, 10),
      properties: { Para: para, PackID: packId, _tipo_pack: 'kit_girom' }
    });

    (config.components || []).forEach(function (component) {
      items.push({
        quantity: component.qty || 1,
        id: component.id,
        properties: { Para: para, PackID: packId, _tipo_pack: 'kit_girom' }
      });
    });

    return items;
  }

  function refreshDrawerAfterKitAdd(miniCart) {
    if (!miniCart || !window.shopSettings || !window.shopSettings.cartDrawer) {
      window.location.href = '/cart';
      return Promise.resolve();
    }

    if (typeof miniCart.refreshFromSectionsEndpoint === 'function') {
      return miniCart.refreshFromSectionsEndpoint();
    }

    var sectionNames = miniCart.getSectionsToRender().map(function (section) {
      return section.section;
    }).join(',');

    return fetch('/?sections=' + sectionNames)
      .then(function (response) { return response.json(); })
      .then(function (sectionsHtml) {
        miniCart.getSectionsToRender().forEach(function (section) {
          var target = document.getElementById(section.id);
          var sectionHtml = sectionsHtml[section.section];
          if (!target || !sectionHtml) return;
          var innerHtml = miniCart.getSectionInnerHTML(sectionHtml, section.selector);
          if (innerHtml) target.innerHTML = innerHtml;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        miniCart.open();
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  window.__giromSubmitKitForm = function (productFormEl, submitButton) {
    var items = buildKitItems();

    if (!items) {
      alert('Por favor selecciona una opción antes de agregar al carrito.');
      return;
    }

    if (!submitButton) return;

    var miniCart = document.querySelector('mini-cart');

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          alert(response.description || 'No se pudo agregar el kit al carrito.');
          return;
        }

        if (miniCart && response.sections && window.shopSettings && window.shopSettings.cartDrawer) {
          miniCart.renderContents(response);
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: response }));
          return;
        }

        return refreshDrawerAfterKitAdd(miniCart);
      })
      .catch(function (error) {
        console.error('Error agregando kit:', error);
        alert('Hubo un problema agregando el kit. Intenta nuevamente.');
      })
      .finally(function () {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  };

  function handleKitSubmit(evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!document.querySelector('.mensajeAdicional #pro0var')) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var productFormEl = form.closest('product-form') || form.closest('.product-form');
    var submitButton = productFormEl
      ? productFormEl.querySelector('[type="submit"]')
      : form.querySelector('[type="submit"]');

    window.__giromSubmitKitForm(productFormEl, submitButton);
  }

  function updateSubmitState() {
    var selector = document.getElementById('pro0var');
    var buttons = document.querySelectorAll('.product-form__submit');

    buttons.forEach(function (button) {
      if (!selector || !selector.value) {
        button.setAttribute('disabled', 'disabled');
        return;
      }

      var soldOut = false;
      document.querySelectorAll('.mensajeAdicional .item').forEach(function (item) {
        if (parseInt(item.getAttribute('data-stock'), 10) <= 0) soldOut = true;
      });

      if (soldOut) {
        button.setAttribute('disabled', 'disabled');
        button.textContent = 'AGOTADO';
      } else {
        button.removeAttribute('disabled');
      }
    });
  }

  function initKitPage() {
    if (!document.querySelector('.mensajeAdicional #pro0var')) return;

    document.addEventListener('submit', handleKitSubmit, true);

    var mensaje = document.querySelector('.mensajeAdicional');
    var productForm = document.querySelector('.product-form');
    if (mensaje && productForm && !productForm.contains(mensaje)) {
      productForm.prepend(mensaje);
    }

    var selector = document.getElementById('pro0var');
    if (selector) {
      selector.addEventListener('change', updateSubmitState);
    }

    updateSubmitState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKitPage);
  } else {
    initKitPage();
  }
})();
